import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "details-header__body" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "details-header__title" }, "Current balance", -1)
const _hoisted_3 = {
  class: "details-header__balance",
  "data-currency": "USDT"
}
const _hoisted_4 = { class: "details-header__wallet" }
const _hoisted_5 = { class: "details-header__footer" }
const _hoisted_6 = { class: "details-nav section section--mini" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "details-nav-item__title" }, "Deposit", -1)
const _hoisted_8 = { class: "details-nav-item__body" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "details-nav-item__total" }, "Total deposited amount:", -1)
const _hoisted_10 = {
  class: "details-nav-item__value",
  "data-currency": "USDT"
}
const _hoisted_11 = { class: "details-nav-item__footer" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "details-nav-item__stat" }, "Number of deposits made:", -1)
const _hoisted_13 = {
  class: "details-nav-item__stat-value",
  "data-unit": "Times"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "details-nav-item__title" }, "Withdraw", -1)
const _hoisted_15 = { class: "details-nav-item__body" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "details-nav-item__total" }, "Total withdraw amount:", -1)
const _hoisted_17 = {
  class: "details-nav-item__value",
  "data-currency": "USDT"
}
const _hoisted_18 = { class: "details-nav-item__footer" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "details-nav-item__stat" }, "Number of deposits made:", -1)
const _hoisted_20 = {
  class: "details-nav-item__stat-value",
  "data-unit": "Times"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "details-nav-item__title" }, "Referral", -1)
const _hoisted_22 = { class: "details-nav-item__body" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "details-nav-item__total" }, "Bonuses received from:", -1)
const _hoisted_24 = {
  class: "details-nav-item__value",
  "data-currency": "USDT"
}
const _hoisted_25 = { class: "details-nav-item__footer" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "details-nav-item__stat" }, "Total number of invited users:", -1)
const _hoisted_27 = {
  class: "details-nav-item__stat-value",
  "data-unit": "People"
}

import "./DetailsView.scss";
import Button from "@/components/Button/Button.vue";
import {RouterLink, useRoute} from "vue-router";
import {onMounted, ref, watch} from "vue";
import Hat from "@/components/Hat/Hat.vue";
import Icon from "@/components/Icon/Icon.vue";
import {useUserStore} from "@/stores/userStore";
import {useApiStore} from "@/stores/apiStore";
import {MeStatisticEntity} from "@/entities/UserEntity";
import {shorty} from "@/modules/helpers";
import {storeToRefs} from "pinia";


export default /*#__PURE__*/_defineComponent({
  __name: 'DetailsView',
  setup(__props) {

let {api} = useApiStore();
let userStore = useUserStore();

let {me} = storeToRefs(userStore);

let route = useRoute();

let table = ref<string>('withdrawals');
let orderBy = ref<'asc' | 'desc'>('desc');
let statistic = ref<MeStatisticEntity | null>(null)

let changeOrderBy = (key : string) => {

	if(table.value === key) {
		orderBy.value = orderBy.value === 'asc' ? 'desc' : 'asc';
	}else{
		table.value = key;
		orderBy.value = 'desc';
	}

}

onMounted(async () => {
	statistic.value = await api.getStatistic();
});

watch(
	() => route.fullPath,
	() => {
		orderBy.value = 'desc';
	}
);


return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Hat, { class: "details-header section section--mini screen-start" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(me).balance.toFixed(2)), 1),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(shorty)(_unref(me).wallet, 16)), 1)
        ]),
        _createElementVNode("nav", _hoisted_5, [
          _createVNode(Button, {
            color: "brand",
            is: _unref(RouterLink),
            to: "/wallet/top-up",
            class: "details-header__button"
          }, {
            default: _withCtx(() => [
              _createVNode(Icon, {
                name: "plus",
                size: 1.3
              }),
              _createTextVNode(" Top up ")
            ]),
            _: 1
          }, 8, ["is"]),
          _createVNode(Button, {
            color: "light",
            is: _unref(RouterLink),
            to: "/wallet/withdrawal",
            class: "details-header__button"
          }, {
            default: _withCtx(() => [
              _createVNode(Icon, {
                name: "up",
                size: 1.05
              }),
              _createTextVNode(" Withdraw ")
            ]),
            _: 1
          }, 8, ["is"])
        ])
      ]),
      _: 1
    }),
    (_unref(statistic))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("menu", _hoisted_6, [
            _createVNode(_unref(RouterLink), {
              class: "details-nav__item details-nav-item card card--mini",
              to: "/wallet/deposits",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(changeOrderBy)('deposits')))
            }, {
              default: _withCtx(() => [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(statistic).deposits.amount.toFixed(2)), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(statistic).deposits.count), 1)
                ]),
                _createElementVNode("i", {
                  class: _normalizeClass(["details-nav-item__sort", {
					'details-nav-item__sort--bottom' : _unref(orderBy) === 'desc' || _unref(table) !== 'deposits',
					'details-nav-item__sort--top' : _unref(orderBy) === 'asc' && _unref(table) === 'deposits'
				}])
                }, [
                  _createVNode(Icon, { name: "up" })
                ], 2)
              ]),
              _: 1
            }),
            _createVNode(_unref(RouterLink), {
              class: "details-nav__item details-nav-item card card--mini",
              to: "/wallet/withdrawals",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(changeOrderBy)('withdrawals')))
            }, {
              default: _withCtx(() => [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("p", _hoisted_17, _toDisplayString(_unref(statistic).withdrawals.amount.toFixed(2)), 1)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(statistic).withdrawals.count), 1)
                ]),
                _createElementVNode("i", {
                  class: _normalizeClass(["details-nav-item__sort", {
					'details-nav-item__sort--bottom' : _unref(orderBy) === 'desc' || _unref(table) !== 'withdrawals',
					'details-nav-item__sort--top' : _unref(orderBy) === 'asc' && _unref(table) === 'withdrawals'
				}])
                }, [
                  _createVNode(Icon, { name: "up" })
                ], 2)
              ]),
              _: 1
            }),
            _createVNode(_unref(RouterLink), {
              class: "details-nav__item details-nav-item card card--mini",
              to: "/wallet/referrals",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(changeOrderBy)('referrals')))
            }, {
              default: _withCtx(() => [
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("p", _hoisted_24, _toDisplayString(_unref(statistic).referrals.amount.toFixed(2)), 1)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createElementVNode("p", _hoisted_27, _toDisplayString(_unref(statistic).referrals.count), 1)
                ]),
                _createElementVNode("i", {
                  class: _normalizeClass(["details-nav-item__sort", {
					'details-nav-item__sort--bottom' : _unref(orderBy) === 'desc' || _unref(table) !== 'referrals',
					'details-nav-item__sort--top' : _unref(orderBy) === 'asc' && _unref(table) === 'referrals'
				}])
                }, [
                  _createVNode(Icon, { name: "up" })
                ], 2)
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_RouterView, null, {
            default: _withCtx(({ Component }) => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { "order-by": _unref(orderBy) }, null, 8, ["order-by"]))
            ]),
            _: 1
          })
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}
}

})